// var map = {};
$(function() {
	var map = {
		vars: {
			map: {},
			center: {
				lat: 38.8837923,
				lon: -8.3128188,
				zoom: 9.75
			}
		},
		el: {
			main: $('#map')
		},
		init: function() {
			var self = this;
			if (self.el.main.length > 0) { //Only initialize if element map exists

				if (self.el.main.data('center')) {
					self.vars.center = self.el.main.data('center');
				}

				var center = new google.maps.LatLng(self.vars.center.lat, self.vars.center.lon, self.vars.center.zoom);
				this.vars.map = new google.maps.Map(this.el.main[0], {
					zoom: self.vars.center.zoom,
					center: center,
					disableDefaultUI: true,
					//draggable: false,
					scrollwheel: false,
					styles: [{
							"featureType": "administrative",
							"elementType": "labels.text.fill",
							"stylers": [{
								"color": "#444444"
							}]
						},
						{
							"featureType": "landscape",
							"elementType": "all",
							"stylers": [{
								"color": "#f2f2f2"
							}]
						},
						{
							"featureType": "poi",
							"elementType": "all",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "road",
							"elementType": "all",
							"stylers": [{
									"saturation": -100
								},
								{
									"lightness": 45
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "all",
							"stylers": [{
								"visibility": "simplified"
							}]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.icon",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "transit",
							"elementType": "all",
							"stylers": [{
								"visibility": "off"
							}]
						},
						{
							"featureType": "water",
							"elementType": "all",
							"stylers": [{
									"color": "#46bcec"
								},
								{
									"visibility": "on"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "geometry.fill",
							"stylers": [{
								"color": "#280071"
							}]
						},
						{
							"featureType": "water",
							"elementType": "labels.text.fill",
							"stylers": [{
								"hue": "#00dfff"
							}]
						}
					]
				});

				//add markers
				var data = this.el.main.data('json');
				data.forEach(function(e) {
					new google.maps.Marker({
						position: new google.maps.LatLng(e.lat, e.lon),
						icon: '/assets/images/marker.png',
						map: self.vars.map
					});
				});
			}
		}
	}


	map.init();
});